import { render, staticRenderFns } from "./ReSendQueueStep1.vue?vue&type=template&id=a40deb7a&scoped=true&"
import script from "./ReSendQueueStep1.vue?vue&type=script&lang=js&"
export * from "./ReSendQueueStep1.vue?vue&type=script&lang=js&"
import style0 from "./ReSendQueueStep1.vue?vue&type=style&index=0&id=a40deb7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40deb7a",
  null
  
)

export default component.exports